import React, { FC, useState } from "react";

import Button from "../../../../../components/elements/Button";
import CustomUrlModal from "./CustomUrlModal";
import UtmParamsModal from "./UtmParamsModal";
import classes from "./Controls.module.scss";

type ControlsProps = {
  selectedLandingPage: string;
  handleSelectLandingPage: (selectedLandingPage: string) => void;
};

const Controls: FC<ControlsProps> = ({ selectedLandingPage, handleSelectLandingPage }) => {
  const [isCustomUrlModalOpen, setIsCustomUrlModalOpen] = useState(false);
  const [isUtmParamsModalOpen, setIsUtmParamsModalOpen] = useState(false);

  const handleCustomUrlModalOpen = () => setIsCustomUrlModalOpen(true);
  const handleCustomUrlModalClose = () => setIsCustomUrlModalOpen(false);

  const handleUtmParamsModalOpen = () => setIsUtmParamsModalOpen(true);
  const handleUtmParamsModalClose = () => setIsUtmParamsModalOpen(false);

  const handleUrlSave = (url: string) => {
    handleSelectLandingPage(url);
  };

  return (
    <div className={classes.controls}>
      <Button className={classes.controlButton} onClick={handleUtmParamsModalOpen} disabled={!selectedLandingPage}>
        Add UTM Parameters
      </Button>
      <Button className={classes.controlButton} onClick={handleCustomUrlModalOpen}>
        Enter Custom Url
      </Button>

      <UtmParamsModal
        selectedLandingPage={selectedLandingPage}
        isOpen={isUtmParamsModalOpen}
        handleClose={handleUtmParamsModalClose}
        handleSave={handleUrlSave}
      />
      <CustomUrlModal
        isOpen={isCustomUrlModalOpen}
        handleClose={handleCustomUrlModalClose}
        handleSave={handleUrlSave}
      />
    </div>
  );
};

export default Controls;
